import styled, { keyframes } from 'styled-components';
import { Link as LinkS } from 'react-scroll';
import { Link as LinkR } from 'react-router-dom';
import { FaTimes, FaUser, FaHome, FaChartLine, FaChartPie, FaCreditCard } from 'react-icons/fa';
import { HiOutlineCurrencyDollar } from 'react-icons/hi';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'


export const Container = styled.div`
  color: #000;
  min-height: 75vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 8px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    108deg,
    rgba(194, 178, 128, 1) 0%,
    rgb(220, 222, 216) 100%
  );

  @media screen and (max-width: 490px){
    position: unset;
    height: 95vh;
    
  }
`;

export const AccontWrapper = styled.div`
  color: #000;
  display: flex;
  flex-direction: row;
  overflow: hidden;
  min-width: 95%;
  max-width: 99%;
  margin-top: 80px;
  min-height: 80%;

  @media screen and (min-width: 490px){
    min-width: 62%;
    max-width: 100%;
    min-height: 800px;
  }
`;

export const SidebarContainer = styled.aside`
  width: 6%;
  border-radius: 12px 0px 0px 12px;
  height: auto;
  background: grey;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  left: 0;
  transition: 0.3s ease-in-out;
  
  @media screen and (max-width: 490px) {
    min-width: 12%;
  }
`;


export const SidebarWrapper = styled.div`
  color: #fff;
  align-items: center;
  justify-content: space-around;
`;

export const Icon = styled.div`
  text-align: center;
  padding: 28px;

  @media screen and (max-width: 480px) {
  }
`;


export const IconNav = styled(LinkR)`
  margin-left: 32px;
  margin-top: 32px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (min-width: 490px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;


const loadingAnimation = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;


export const CloseIcon = styled(FaTimes)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;

export const LineIcon = styled(FaChartLine)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;

export const CryptoIcon = styled(HiOutlineCurrencyDollar)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;


export const PieIcon = styled(FaChartPie)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;


export const CardIcon = styled(FaCreditCard)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;


export const UserIcon = styled(FaUser)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;


export const HomeIcon = styled(FaHome)`
  display: flex;
  font-size: 1.5rem;
  text-decoration: none;
  list-style: none;
  transition: 0.2s ease-in-out;
  text-decoration: none;
  color: ${({ selected }) => (selected ? '#c2b280' : 'fff')};
  cursor: pointer;

  &:hover {
    color: #c2b280;
    transition: 0.2s ease-in-out;
  }
`;


export const Card = styled.div`
  background-color: #fff;
  border-radius: 0px 12px 12px 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  width: 100%;
  min-height: 80%;
`;

export const AccountFormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  min-width: 80%;

  @media screen and (max-width: 490px) {
    margin-top: 100px;
    height: 80%;
    margin-bottom: 40px;
  }
`;


export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: gray;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;


export const LoadingHeaderBar = styled.div`
  width: 60%;
  height: 12px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;


export const LoadingDescriptionBar = styled.div`
  width: 70%;
  height: 12px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;


export const LoadingButton = styled.div`
  width: 42px;
  height: 20px; /* Adjust height as needed */
  background: linear-gradient(to right, #e0e0e0 8%, #f0f0f0 18%, #e0e0e0 33%);
  background-size: 200px 100%;
  animation: ${loadingAnimation} 1.5s infinite;
  padding: 12px;
  margin: 12px;
`;


export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: black;
  margin-bottom: 30px;
  @media screen and (min-width: 490px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: #fff;
  max-width: 400px;
  height: auto;
  width: auto;
  z-index: 1;
  display: grid;
  margin: 0 auto;
  padding: 80px 32px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  min-width: 290px;

  @media screen and (min-width: 490px) {
    padding: 32px 32px;
  }
`;

export const AccountDetailsSection = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 600px;
  width: 100%;
  margin: 20px auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const TransactionTable = styled.table`
 width: 100%;
 border-collapse: collapse;
 margin: 20px 0;

   @media screen and (min-width: 490px) {
    max-width: 90%;
  }
`;

export const TransactionRow = styled.div`
  display: inline-flex;
  background: white;
  flex-direction: row;
  margin-top: 20px;
  padding: 20px;
  grid-gap: 20px;
  justify-content: center;
  margin-right: 2px;
  margin-left: 2px;
  max-width: 95%;
  align-items: center;
  
  @media screen and (min-width: 490px){
    justify-content: space-around;
    min-width: 900px;
    grid-template-columns: 400px 800px;
    padding: 20px;
  }
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: gray;
`;

export const FormInput = styled.input`
  padding: 16px 16px;
  margin-bottom: 32px;
  border-radius: 2px;
  &:focus {
    outline: none;
    border: 2px solid #c2b280;
  }
`;

export const FormButton = styled.button`
  background: #c2b280;
  padding: 12px 16px;
  border: none;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  &:focus {
    outline: none;
    border: 2px solid #c2b280;
  }
`;

export const ThumbnailImage = styled.img`
  width: 600px;
  height: auto;
  // object-fit: cover; Uncomment if needed
  background: #232a34;
  justify-content: center;
  border: 12px solid #c2b280; /* Base border color */
  // border-image-source: url('path-to-your-ornate-border-image.png'); /* Path to ornate border image */
  // border-image-slice: 30 fill; /* Adjust slice to fit your image */
  // border-image-width: 10px; /* Width of the border image */
  // border-image-outset: 0; /* Optional: adjust if needed */
  // border-image-repeat: stretch; /* Adjust if needed */

  @media screen and (max-width: 490px) {
    justify-content: space-around;
    width: 225px;
  }
`;


export const TransactionTableButton = styled.button`
  color: ${({ status }) => (status === 'succeeded' ? '#fff' : 'black')};
  border: none;
  border-radius: 50px;
  background: ${({ status }) => (status === 'succeeded' ? 'green' : 'c2b280')};
  font-size: 16px;
  padding: 10px 22px;
  border: 2px solid white;
  // cursor: ${({ status }) => (status === 'succeeded' ? 'mouse' : 'pointer')};
  &:focus {
    outline: none;
    border: 2px solid gold;
  }
  
 @media screen and (max-width: 490px){
    font-size: 12px;
    padding: 6px;
  }
`;


export const LinkButton = styled(LinkR)`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin-top: 24px;
  min-width: 100px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }

   @media screen and (min-width: 490px){
    min-width: 200px;
  }
`;

export const FormH2 = styled.div`
  color: #c2b280;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 12px;
  margin-bottom: 12px;
  
 @media screen and (max-width: 490px){
    text-align: center;
  }
  
`;

export const FormText = styled.p`
  width: 90%;
  font-size: 12px;
  line-height: 12px;
  color: black;
  margin-bottom: 6px;
`;


export const SectionTitle = styled.h2`
  margin-bottom: 20px;
  color: gray;
  font-size: 18px;
  font-weight: 400;
`;

export const TransactionList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

export const TransactionItem = styled.li`
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TransactionTableHeader = styled.thead`
 
`;

export const TransactionTableRow = styled.tr`

`;

export const TransactionTableBody = styled.tbody`
`;

export const TransactionHeader = styled.th`
 border: none;
 padding: 8px;
 background-color: #fff;
 text-align: left;
 color: grey;
 @media screen and (max-width: 490px){
    font-size: 10px;
    padding: 1px;
  }
`;



export const TransactionData = styled.td`
 border-top: 1px solid #ddd;
 padding: 8px;
 color: black;
 
 @media screen and (max-width: 490px){
    font-size: ${({ variableText }) => (variableText ? '10px' : '12px')};
    padding: 6px;

  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIcon = styled(AiOutlineLoading3Quarters)`
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #c2b280;
  border-radius: 50%; 
  width: 24px; 
  height: 24px; 
  animation: ${spin} 1s linear infinite;
`